import { render, staticRenderFns } from "./WorkerClaimsList.vue?vue&type=template&id=3bb28ad5&scoped=true&"
import script from "./WorkerClaimsList.vue?vue&type=script&lang=js&"
export * from "./WorkerClaimsList.vue?vue&type=script&lang=js&"
import style0 from "./WorkerClaimsList.vue?vue&type=style&index=0&id=3bb28ad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb28ad5",
  null
  
)

export default component.exports